<template>
    <div class="user_control bg-white dark:bg-neutral-900 md2:!bg-transparent md2:h-full md2:block overflow-hidden md2:overflow-visible fixed top-17 sm:top-20 md2:top-0 right-0 w-full md2:relative grow basis-0 transition-all duration-300 md2:transition-none min-w-max dark:text-white"
        :class="[open ? '!h-[calc(100vh-70px)] sm:!h-[calc(100vh-80px)] md2:!h-auto' : 'h-[0vh]', collapsedMenu ? 'grow-0' : '']">
        <ul ref="navmenu" class="h-full text-lg divide-y divide-gray-200 dark:divide-neutral-800 md2:divide-y-0 md2:text-sm flex flex-col w-full md2:bg-none md2:flex-row md2:justify-end min-w-max relative
            min-h-[calc(100vh-70px)] sm:min-h-[calc(100vh-80px)] md2:min-h-0">
            <ul class="flex flex-col md2:flex-row divide-y divide-gray-200 dark:divide-neutral-800 md2:divide-y-0">
                <li v-for="item in JSON.parse($attrs.menuitems)" class="max-h-20 h-20 md2:h-full ">
                    <a class="h-full block flex items-center justify-center px-4 cursor-pointer hover:scale-95 hover:underline transition duration-300 active:!scale-75 ref_navbar_item dark:text-white"
                        :class="[collapsedMenu && open ? 'md2:py-3' : '']" :href="$homeUrl + item.url">{{ $t(item.name) }}
                    </a>
                </li>
            </ul>
            <li class="h-full max-h-20">
                <a class="h-full px-4 block flex items-center text-white cursor-pointer justify-center hover:scale-95 transition duration-300  group active:!scale-75"
                    :href="$homeUrl + '/' + ($attrs.client.listing_slug || 'acco')">
                    <span class="block bg-gradient px-5 py-2 rounded-full group-active:bg-primary-dark">
                        {{ $t('Book now') }}!
                    </span>
                </a>
            </li>

            <li class="md:hidden h-full max-h-20">
                <app_modal>
                    <!-- Modal content -->
                    <template #modal_content>
                        <div
                            class="bg-white dark:bg-neutral-800 rounded-md shadow-xl p-8 animate-in fade-in zoom-in w-full max-w-lg">
                            <div class="flex flex-col justify-between justify-items-center">

                                <a
                                    v-for="item in $attrs.locales"
                                    :key="item.locale"
                                    :href="item.url"
                                    class="p-2 hover:bg-gray-100 dark:hover:bg-neutral-600 text-gray-800 dark:text-white rounded-full py-1 px-2 transition duration-300 cursor-pointer flex justify-start items-center"
                                    :class="{
                                        'opacity-60 pointer-events-none' : item.locale === $attrs.currentlocale
                                    }"
                                >
                                    <!-- Flag -->
                                    <country-flag
                                        style="margin-top: -10px;"
                                        :country="item.locale === 'en' ? 'gb' : item.locale"
                                        size="normal"
                                        loading="lazy"
                                        :rounded="true"
                                    />

                                    <!-- Language string -->
                                    <div class="ml-2">{{ $t('lang.' + item.locale) }}</div>
                                </a>

                            </div>
                        </div>
                    </template>

                    <!-- Modal button -->
                    <template #modal_button>
                        <div
                            class="w-fit mx-auto h-8 px-1 flex gap-1 items-center justify-center rounded-full bg-gray-100 dark:bg-neutral-800 hover:bg-white hover:text-primary cursor-pointer transition"
                        >
                            <!-- Left icon -->
                            <svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg"
                                fill="currentColor" viewBox="0 0 640 640">
                                <path d="M320.2 112C435 112.1 528 205.2 528 320C528 342.1 524.6 363.4 518.2 383.4C516.2 383.8 514.1 384 512 384L509.3 384C500.8 384 492.7 380.6 486.7 374.6L457.4 345.3C451.4 339.3 448 331.2 448 322.7L448 272C448 263.2 455.2 256 464 256C472.8 256 480 248.8 480 240C480 231.2 472.8 224 464 224L440 224C426.7 224 416 234.7 416 248C416 261.3 405.3 272 392 272L336 272C327.2 272 320 279.2 320 288C320 296.8 312.8 304 304 304L278.6 304C266.1 304 256 293.9 256 281.4C256 275.4 258.4 269.6 262.6 265.4L332.7 195.3C334.8 193.2 336 190.3 336 187.3C336 181.1 330.9 176 324.7 176L310.6 176C298.1 176 288 165.9 288 153.4C288 147.4 290.4 141.6 294.6 137.4L317.7 114.3C318.5 113.5 319.3 112.8 320.2 112.1zM502.4 420.1C469.6 479.7 408.5 521.5 337.2 527.3C336.5 525 336.1 522.5 336.1 520C336.1 506.7 325.4 496 312.1 496L285.4 496C276.9 496 268.8 492.6 262.8 486.6L233.5 457.3C227.5 451.3 224.1 443.2 224.1 434.7L224.1 368C224.1 350.3 238.4 336 256.1 336L354.8 336C363.3 336 371.4 339.4 377.4 345.4L406.7 374.7C412.7 380.7 420.8 384.1 429.3 384.1L434.8 384.1C443.3 384.1 451.4 387.5 457.4 393.5L473.4 409.5C477.6 413.7 483.4 416.1 489.4 416.1C494.2 416.1 498.7 417.6 502.4 420.2zM320 576L346.2 574.7C337.6 575.6 328.9 576 320 576zM346.2 574.7C475.3 561.6 576 452.6 576 320C576 178.6 461.4 64 320 64L320 64C178.6 64 64 178.6 64 320C64 447.5 157.2 553.3 279.3 572.8C292.5 574.9 306.1 576 320 576zM251.3 187.3L219.3 219.3C213.1 225.5 202.9 225.5 196.7 219.3C190.5 213.1 190.5 202.9 196.7 196.7L228.7 164.7C234.9 158.5 245.1 158.5 251.3 164.7C257.5 170.9 257.5 181.1 251.3 187.3z"/>
                            </svg>

                            <!-- Current language text -->
                            <span>{{ $t('lang.' + $attrs.currentlocale) }}</span>

                            <!-- Arrow -->
                            <svg xmlns="http://www.w3.org/2000/svg"
                                class="w-3 h-3 mr-2 ml-2" fill="currentColor"
                                viewBox="0 0 512 512">
                                <path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/>
                            </svg>
                        </div>
                    </template>
                </app_modal>

            </li>

            <li v-if="$attrs.client.allow_login" class="h-full max-h-20">
                <div class="h-full flex justify-center items-center pr-4">
                    <div v-if="$attrs.user">
                        <app_dropdown>
                            <template slot="toggler">
                                <div class="h-10 w-10 mt-1 overflow-hidden rounded-full flex items-center justify-center hover:scale-90 active:scale-75 transition cursor-pointer bg-primary border-3 border-primary group">
                                    <img :src="JSON.parse($attrs.user).avatar" class="h-10 w-10 overflow-hidden rounded-full flex items-center justify-center group-hover:scale-90 group-active:scale-75 transition cursor-pointer bg-primary object-cover">
                                </div>
                            </template>
                            <app_dropdown_content class="min-w-3xs">
                                <ul>
                                    <li>
                                        <div class="p-2 border-b border-gray-300 dark:border-neutral-600 flex gap-2">
                                            <div class="w-12 h-12 bg-gray-300 rounded-lg">
                                                <img :src="JSON.parse($attrs.user).avatar" class="w-full h-full object-cover rounded-lg">
                                            </div>
                                            <div class="flex flex-col">
                                                <span class="text-lg font-bold capitalize">{{ $t('Hello') }} {{ JSON.parse($attrs.user).first_name }}</span>
                                                <a :href="$baseUrl + '/dashboard/account'" class="hover:underline cursor-pointer text-primary capitalize">{{ $t('my account') }}</a>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <a class="block w-full h-full p-2 hover:bg-gray-100 capitalize cursor-pointer dark:hover:bg-neutral-700"
                                            :href="$baseUrl + '/dashboard'">
                                            {{ $t('Dashboard') }}
                                        </a>
                                    </li>
                                    <!-- <li>
                                        <a class="block w-full h-full p-2 hover:bg-gray-100 capitalize cursor-pointer dark:hover:bg-neutral-700"
                                            :href="$baseUrl + '/favorites'">
                                            {{ $t('favorites') }}
                                        </a>
                                    </li> -->
                                    <li class="border-t border-gray-300 dark:border-neutral-600">
                                        <a class="block w-full h-full p-2 hover:bg-gray-100 cursor-pointer dark:hover:bg-neutral-700" onclick="event.preventDefault();
                                            document.getElementById('logout-form').submit();">
                                            {{ $t('Logout') }}
                                        </a>
                                    </li>
                                </ul>
                            </app_dropdown_content>
                        </app_dropdown>
                    </div>
                    <a v-else :href="$baseUrl + '/login'" class="h-10 w-10 overflow-hidden rounded-full flex items-center justify-center hover:scale-90 active:scale-75 transition cursor-pointer border-3 border-gray-300 bg-gray-300 dark:bg-neutral-700">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                            class="h-5 w-5 text-white stroke-current">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z">
                            </path>
                        </svg>
                    </a>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    data() {
        return {
            open: false,
            collapsedMenu: false,
            menuWidth: 0,
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },
    methods: {
        onResize() {
            this.open = false
            $("body").removeClass("scroll_lock")
            if (window.innerWidth - this.menuWidth - 250 < 545) {
                this.collapsedMenu = true;
                this.$root.$emit("collapsedMenu", true);
            } else {
                this.collapsedMenu = false
                this.$root.$emit("collapsedMenu", false);
            }
        },
    },
    mounted() {
        this.$nextTick(() => {
            var totalWidth = 0;
            var items = this.$refs.navmenu.querySelectorAll('.ref_navbar_item');
            items.forEach((element) => {
                totalWidth += element.textContent.trim().length * 11 + 30;
            });
            this.menuWidth = totalWidth;
            window.addEventListener('resize', this.onResize);
            this.onResize();
        })
        this.$root.$on("showMenu", (msg) => {
            this.open = msg;
        });
    }
}
</script>

<style>
.slide-enter-active {
    transition: all .3s ease;
}

.slide-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-enter,
.slide-leave-to {
    transform: translateX(10px);
    opacity: 0;
}
</style>